<template>
  <div>
    <menu-content-container
      :chip="$t('forms.text_properties')"
      chip-secondary
      :border-bottom="false"
    >
    </menu-content-container>

    <paddingForm
      data-testid="text-margin"
      :disabled="disabledPadding"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      @reset="padding.reset"
    ></paddingForm>

    <menu-content-container :border-bottom="false" :margin-top="16">
      <content-row>
        <hide-on-mobile></hide-on-mobile>
      </content-row>

      <content-row :margin-top="16" :margin-bottom="20">
        <hide-on-desktop></hide-on-desktop>
      </content-row>
    </menu-content-container>
  </div>
</template>

<script lang="ts" setup>
  import paddingForm from "./paddingForm.vue";
  import hideOnMobile from "./components/hideOnMobile.vue";
  import hideOnDesktop from "./components/hideOnDesktop.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useBlockAttr } from "@/composables/useBlockAttr";

  import { computed } from "vue";

  const mjmlStore = useMjmlStore();
  const { nullable } = useBlockAttr({ mode: "active" });

  const disabledPadding = computed(() => {
    return mjmlStore.getActiveBlockPropDisabled("padding");
  });

  const padding = nullable("padding");
</script>
